import { getMyOrg } from '@/api/organ'

// 默认品牌来自环境变量（各 .env.* 可不同）；没配就用内置兜底
const DEFAULT_NAME = process.env.VUE_APP_SYSTEM_NAME || '易调研系统'
const DEFAULT_LOGO = process.env.VUE_APP_SYSTEM_LOGO || require('@/assets/ys2.png')

/**
 * 浏览器标签页的图标与标题不在 Vue 组件里，品牌变化时同步一次
 */
function applyBrand({ systemName, logoUrl } = {}) {
  const icon = document.getElementById('app-favicon')
  if (icon) icon.href = logoUrl || DEFAULT_LOGO
  document.title = systemName || DEFAULT_NAME
}

/**
 * 系统品牌（Logo / 系统名）
 *
 * 每个组织可以有自己的系统名和 Logo：登录后拉一次 /org/mine，
 * 有组织就用组织的，没有组织（如系统管理员还没归属）就用环境变量里的默认品牌。
 * 存 localStorage 是为了刷新页面时先显示上一次的品牌，避免闪一下默认值。
 */
export default {
  namespaced: true,
  state: {
    systemName: localStorage.getItem('edb-systemName') || '',
    logoUrl: localStorage.getItem('edb-systemLogo') || ''
  },
  getters: {
    // 组件统一从这里取品牌，默认值只维护一份
    brandName: state => state.systemName || DEFAULT_NAME,
    brandLogo: state => state.logoUrl || DEFAULT_LOGO
  },
  mutations: {
    changeBrand(state, brand) {
      const data = brand || {}
      state.systemName = data.systemName || ''
      state.logoUrl = data.logoUrl || ''
      localStorage.setItem('edb-systemName', state.systemName)
      localStorage.setItem('edb-systemLogo', state.logoUrl)
      applyBrand(state)
    }
  },
  actions: {
    async loadBrand({ commit }) {
      try {
        const res = await getMyOrg()
        if (res && res.code === 200) {
          commit('changeBrand', res.data)
        }
      } catch (e) {
        // 接口失败不影响页面，保持当前品牌即可
      }
    }
  }
}

// 刷新页面时先用 localStorage 里的品牌，接口回来再覆盖
applyBrand({
  systemName: localStorage.getItem('edb-systemName'),
  logoUrl: localStorage.getItem('edb-systemLogo')
})
